import Router from 'preact-router';

import Home from './routes/home';
import FourOhFour from './routes/404';


function App() {
  return (
    <main>
      <Router>
        <Home exact path="/"/>
        <FourOhFour default/>
      </Router>
    </main>
  );
}

export default App;
